var Mn = require('backbone.marionette'),
    _ = require('underscore'),
    body = $('html, body'),
    Helper =  Mn.Object.extend({
        link: function (href) {
            var a = document.createElement('a');
            a.href = href;
            return a.toString();
        },
        scripts_difference: function (elements_a, elements_b) {
            var self = this,
                difference = _.difference(
                    elements_a.map(function () {
                        return self.link(this.src);
                    }).toArray(),
                    elements_b.map(function () {
                        return self.link(this.src);
                    }).toArray()
                );
            return _.map(difference, function (src) {
                return {url: src, inBody: true};
            })
        },
        content: function (content) {
            return content.trim() || '<div ><span class="empty"></span></div>';
        },
        anchor: function(target, speed, callback){
            if(target === undefined || target === null || target === false){
                target = 0;
            } else if($.isNumeric(target)){
                //pass
            } else{
                target = $(target);
                if(target.length >= 1){
                    target = target.offset().top - $('.menu__section').innerHeight();
                }else{
                    target = 0;
                }
            }
            body.stop().animate({
                scrollTop: target
            }, speed || 500, 'swing', function() {
                if(callback) callback(this);
            });
        },
        serializeForm: function ($form) {
            var unindexed_array = $form.serializeArray();
            var indexed_array = {};
    
            $.map(unindexed_array, function(n, i){
                indexed_array[n['name']] = n['value'];
            });
    
            return indexed_array;
        }
    });
module.exports = new Helper();



//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/libs/helpers.js
// module id = 9
// module chunks = 14 15